import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'maskFilter'
})
export class MaskFilterPipe implements PipeTransform {

  transform(list: any[], filterText: string): any {
    return list ? list.filter(item => item.maskName.search(new RegExp(filterText, 'i')) > -1) : [];
  }

}
